import { MockServiceStore } from "./MockServiceStore";

/**
 * StructureCast - Shipment
 */
export interface StructureCastShipment {
  id: string;
  projectId: string;
  requestDate: string;
  shipDate: string;
  loadDates: string[];
  requestedBy: string;
  customerContact: {
    name: string;
    phone: string;
    email: string;
  };
  shipToAddress: string;
  shipToCity: string;
  shipToState: string;
  carrier: string;
  trailerType: "flat" | "drop";
  totalLoads: number;
  requiresSpecialPermits: boolean;
  isOversized: boolean;
  requiresCrane: boolean;
  notes: string;
  status: "draft" | "scheduled" | "loading" | "in_transit" | "delivered";
  createdAt: string;
  updatedAt: string;
}

export const mockStructureCastShipments: StructureCastShipment[] = [
  {
    id: "sc-ship-1",
    projectId: "sc-proj-1",
    requestDate: "2026-01-15",
    shipDate: "2026-01-23",
    loadDates: [
      "2026-01-23",
    ],
    requestedBy: "Office (MSCP)",
    customerContact: {
      name: "Greg Hill (HRCSD — Heritage Ranch WRRF site)",
      phone: "805-227-6230",
      email: "ghill@heritageranchcsd.org",
    },
    shipToAddress: "Heritage Ranch WRRF, Nacimiento Lake Dr",
    shipToCity: "Paso Robles",
    shipToState: "CA",
    carrier: "Mid-State Delivery (flatbed)",
    trailerType: "flat",
    totalLoads: 1,
    requiresSpecialPermits: false,
    isOversized: false,
    requiresCrane: true,
    notes: "Ship from: Mid-State Concrete Products, 1625 E. Donovan Rd., Ste. C, Santa Maria CA 93454. First delivery — SSMH-01 + SSMH-02 deep MH sections (bases, 48\"/36\" risers, 36\" eccentric cones, grade rings). ~50 mi up US-101 to Heritage Ranch. F.O.B. yard. Hourly delivery charge.",
    status: "scheduled",
    createdAt: "2026-01-15T00:00:00.000Z",
    updatedAt: "2026-01-20T00:00:00.000Z",
  },
  {
    id: "sc-ship-2",
    projectId: "sc-proj-1",
    requestDate: "2026-01-28",
    shipDate: "2026-02-13",
    loadDates: [
      "2026-02-13",
      "2026-02-17",
      "2026-02-19",
    ],
    requestedBy: "Office (MSCP)",
    customerContact: {
      name: "Greg Hill (HRCSD — Heritage Ranch WRRF site)",
      phone: "805-227-6230",
      email: "ghill@heritageranchcsd.org",
    },
    shipToAddress: "Heritage Ranch WRRF, Nacimiento Lake Dr",
    shipToCity: "Paso Robles",
    shipToState: "CA",
    carrier: "Mid-State Delivery (flatbed)",
    trailerType: "flat",
    totalLoads: 3,
    requiresSpecialPermits: false,
    isOversized: false,
    requiresCrane: true,
    notes: "Multi-load: Standard MH (SSMH-03/04/05), Mid-Depth MH (SSMH-06/07), and Shallow MH (SSMH-08/09). 3 truckloads from Santa Maria to Heritage Ranch. F.O.B. yard. Hourly delivery charge per quote #25-1585.",
    status: "draft",
    createdAt: "2026-01-28T00:00:00.000Z",
    updatedAt: "2026-01-28T00:00:00.000Z",
  },
];

export const createMockStructureCastShipmentStore = () =>
  new MockServiceStore<StructureCastShipment>({
    mockData: mockStructureCastShipments,
    idField: "id",
    simulateDelay: 200,
    persistKey: "preferred-structurecast-shipments",
  });

export default mockStructureCastShipments;
